"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeadersFetch = void 0;
const getHeadersFetch = (allHeaders, header, isHeadersFromErrorResponse = true) => {
    var _a;
    const headers = isHeadersFromErrorResponse
        ? (_a = allHeaders === null || allHeaders === void 0 ? void 0 : allHeaders.response) === null || _a === void 0 ? void 0 : _a.headers
        : allHeaders;
    return headers === null || headers === void 0 ? void 0 : headers[header];
};
exports.getHeadersFetch = getHeadersFetch;
//# sourceMappingURL=headers.js.map